<template>
  <div class="property-title d-flex flex-row">
    <div class="flex-grow-1">{{ compProps.model.getDocumentationType() }} Documentation:</div>
  </div>
  <v-textarea
    v-model="description"
    density="compact"
    hide-details
    single-line
    variant="outlined"
    class="no-resize field-bordered"
    :disabled="readOnly"
    @focus="onFocus"
    @blur="onBlur"
  />
</template>

<script setup lang="ts">
import { computed, inject, ref } from "vue";
import DocumentationElement from "../mvc/base/documentation-element";
import { PreferenceStore } from "../services/preference-store";
import RappidContext from "../rappid/rappid-context";

const rappidContext: RappidContext = inject<RappidContext>("rappidContext");

const readOnly = ref(PreferenceStore.INSTANCE.isReadOnly);

PreferenceStore.INSTANCE.on("change:isReadOnly", () => {
  readOnly.value = PreferenceStore.INSTANCE.isReadOnly;
});

const compProps = defineProps<{
  model: DocumentationElement;
}>();

const description = computed({
  get(): string {
    return compProps.model.getDocumentation();
  },

  set(documentation: string) {
    compProps.model.setDocumentation(documentation);
  },
});

function onFocus() {
  rappidContext.commandManager.initBatchCommand();
}

function onBlur() {
  rappidContext.commandManager.storeBatchCommand();
}
</script>

<style scoped>
.no-resize :deep(textarea) {
  resize: none !important;
}
.field-bordered :deep(.v-field) {
  box-shadow: none;
}
</style>
